import { endOfDay, isAfter, isBefore, isSameDay, startOfDay, subDays } from 'date-fns'

import { DatepickerValueType } from '@procsea/design-system'

import { OrderTypeSelectorValue } from 'src/components/presentationals/shared/fields'
import { OrderType } from 'src/types'

export const getTypeFromDate = (value: DatepickerValueType<true>): OrderTypeSelectorValue => {
  const today = new Date()
  const [fromDate] = value

  if (fromDate && isBefore(fromDate, startOfDay(today))) {
    return OrderType.PAST
  }

  if (fromDate && isAfter(fromDate, endOfDay(today))) {
    return OrderType.FUTURE
  }

  return OrderType.TODAY
}

export const getMaxDate = (date?: Date) => {
  const today = startOfDay(new Date())

  if (date && isBefore(date, today)) {
    return subDays(today, 1)
  }

  if (date && isSameDay(date, today)) {
    return today
  }

  return undefined
}
